/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({
  name: 'dateRangeToOffset',
  standalone: true
})
export class DateRangeToOffsetPipe implements PipeTransform{

  transform(value: {startDate: string, endDate: string}, ...args: any[]) {
    if (value) {
      return {
        start: this.getOffsetFromDateTime(value.startDate),
        end: this.getOffsetFromDateTime(value.endDate)
      };
    }

    return null;
  }

  private getOffsetFromDateTime(date: string) {
    const _date = new Date(date);
    _date.setHours(0, 0, 0, 0);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return differenceInDays(_date, currentDate);
  }

}
